var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 69,
    viewBox: "0 0 111 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_157_3851)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.9531,
    y: 0.548279,
    width: 34,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4531,
    y: 1.04828,
    width: 33,
    height: 31,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9656 25.5483L43.9712 8.09373H48.0025L50.8917 20.2216H51.0366L54.2241 8.09373H57.6758L60.8548 20.2471H61.0082L63.8974 8.09373H67.9286L62.9343 25.5483H59.3377L56.0139 14.1363H55.8775L52.5621 25.5483H48.9656Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_157_3851)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.953125,
    y: 36.5029,
    width: 34,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.45312,
    y: 37.0029,
    width: 33,
    height: 31,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5021 61.5029H9.54759L15.5732 44.0484H20.3288L26.3459 61.5029H22.3913L18.0192 48.037H17.8828L13.5021 61.5029ZM13.255 54.6421H22.5959V57.5228H13.255V54.6421Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_157_3851)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.9531,
    y: 36.5029,
    width: 34,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.4531,
    y: 37.0029,
    width: 33,
    height: 31,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9272 61.5029H86.7397V44.0484H92.9783C94.734 44.0484 96.2454 44.3978 97.5124 45.0967C98.7795 45.7899 99.7539 46.787 100.436 48.0882C101.123 49.3893 101.467 50.9461 101.467 52.7586C101.467 54.5768 101.123 56.1393 100.436 57.4461C99.7539 58.7529 98.7738 59.7558 97.4954 60.4546C96.2227 61.1535 94.6999 61.5029 92.9272 61.5029ZM90.43 58.341H92.7738C93.8647 58.341 94.7823 58.1478 95.5266 57.7615C96.2766 57.3694 96.8391 56.7643 97.2141 55.9461C97.5948 55.1222 97.7852 54.0597 97.7852 52.7586C97.7852 51.4688 97.5948 50.4149 97.2141 49.5967C96.8391 48.7785 96.2795 48.1762 95.5352 47.7899C94.7908 47.4035 93.8732 47.2103 92.7823 47.2103H90.43V58.341Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_157_3851)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.9531,
    y: 36.5029,
    width: 34,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.4531,
    y: 37.0029,
    width: 33,
    height: 31,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0756 49.0683C58.0075 48.3808 57.7148 47.8467 57.1978 47.466C56.6808 47.0853 55.979 46.895 55.0927 46.895C54.4904 46.895 53.9819 46.9802 53.5671 47.1507C53.1523 47.3154 52.8342 47.5455 52.6126 47.841C52.3967 48.1365 52.2887 48.4717 52.2887 48.8467C52.2773 49.1592 52.3427 49.4319 52.4847 49.6649C52.6325 49.8978 52.8342 50.0995 53.0898 50.27C53.3455 50.4347 53.641 50.5796 53.9762 50.7046C54.3114 50.824 54.6694 50.9262 55.0501 51.0115L56.6183 51.3865C57.3796 51.5569 58.0785 51.7842 58.7148 52.0683C59.3512 52.3524 59.9023 52.7018 60.3683 53.1166C60.8342 53.5313 61.195 54.02 61.4506 54.5825C61.712 55.145 61.8455 55.7899 61.8512 56.5171C61.8455 57.5853 61.5728 58.5115 61.033 59.2955C60.4989 60.074 59.7262 60.6791 58.7148 61.1109C57.7092 61.537 56.4961 61.7501 55.0756 61.7501C53.6665 61.7501 52.4393 61.5342 51.3938 61.1024C50.354 60.6705 49.5415 60.0313 48.9563 59.1847C48.3768 58.3325 48.0728 57.2785 48.0444 56.0228H51.6154C51.6552 56.608 51.8228 57.0967 52.1183 57.4887C52.4194 57.8751 52.82 58.1677 53.32 58.3666C53.8256 58.5597 54.3967 58.6563 55.033 58.6563C55.658 58.6563 56.2006 58.5654 56.6609 58.3836C57.1268 58.2018 57.4876 57.949 57.7433 57.6251C57.9989 57.3012 58.1268 56.9291 58.1268 56.5086C58.1268 56.1166 58.0103 55.787 57.7773 55.52C57.5501 55.2529 57.2148 55.0257 56.7717 54.8382C56.3342 54.6507 55.7972 54.4802 55.1609 54.3268L53.2603 53.8495C51.7887 53.4916 50.6268 52.9319 49.7745 52.1705C48.9222 51.4092 48.4989 50.3836 48.5046 49.0938C48.4989 48.037 48.7802 47.1137 49.3484 46.324C49.9222 45.5342 50.7092 44.9177 51.7092 44.4745C52.7092 44.0313 53.8455 43.8097 55.1183 43.8097C56.4137 43.8097 57.5444 44.0313 58.5103 44.4745C59.4819 44.9177 60.2376 45.5342 60.7773 46.324C61.3171 47.1137 61.5955 48.0285 61.6126 49.0683H58.0756Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_157_3851",
    x: -1.04688,
    y: -39.4517,
    width: 114,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_157_3851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_157_3851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_157_3851",
    x: -39.0469,
    y: -3.49707,
    width: 114,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_157_3851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_157_3851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_157_3851",
    x: 36.9531,
    y: -3.49707,
    width: 114,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_157_3851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_157_3851",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_157_3851",
    x: -1.04688,
    y: -3.49707,
    width: 114,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_157_3851"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_157_3851",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasd);
export default __webpack_public_path__ + "static/media/wasd.797988674fe75a2a6a42eddfdfdbfbd0.svg";
export { ForwardRef as ReactComponent };